(function () {
  if (customElements.get('noendy-hero-slider')) return;

  class NoendyHeroSlider extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.autoplayId = null;
      this.touchStartX = null;
      this.touchEndX = null;
    }

    connectedCallback() {
      this.track = this.querySelector('[data-hero-track]');
      this.slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-hero-dot]'));
      this.arrows = Array.from(this.querySelectorAll('[data-hero-arrow]'));

      if (this.slides.length <= 1) return;

      this.autoplayDuration = parseInt(this.dataset.autoplay, 10) || 6000;
      this.autoplayEnabled = this.dataset.autoplayEnabled === 'true';
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.arrows.forEach((btn) => {
        btn.addEventListener('click', () => {
          const dir = btn.dataset.heroArrow;
          if (dir === 'next') this.next();
          else this.prev();
          this.restartAutoplay();
        });
      });

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.goTo(parseInt(dot.dataset.heroDot, 10));
          this.restartAutoplay();
        });
      });

      this.addEventListener('touchstart', (e) => {
        this.touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      this.addEventListener('touchend', (e) => {
        this.touchEndX = e.changedTouches[0].screenX;
        this.handleSwipe();
      }, { passive: true });

      // Hover/focus üzerine geldiğinde autoplay durdurulmuyor — mouse over
      // animasyonu kesintisiz devam etsin (kullanıcı isteği).
      this.addEventListener('focusin', () => this.stopAutoplay());
      this.addEventListener('focusout', () => this.startAutoplay());

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.stopAutoplay();
        else this.startAutoplay();
      });

      this.update();
      this.startAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }

    next() {
      this.currentIndex = (this.currentIndex + 1) % this.slides.length;
      this.update();
    }

    prev() {
      this.currentIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
      this.update();
    }

    goTo(index) {
      if (index < 0 || index >= this.slides.length) return;
      this.currentIndex = index;
      this.update();
    }

    update() {
      this.track.style.transform = `translateX(-${this.currentIndex * 100}%)`;

      this.slides.forEach((slide, i) => {
        if (i === this.currentIndex) {
          slide.setAttribute('data-active', '');
          slide.setAttribute('aria-hidden', 'false');
        } else {
          slide.removeAttribute('data-active');
          slide.setAttribute('aria-hidden', 'true');
        }
      });

      this.dots.forEach((dot, i) => {
        if (i === this.currentIndex) {
          dot.setAttribute('data-active', '');
          dot.setAttribute('aria-selected', 'true');
        } else {
          dot.removeAttribute('data-active');
          dot.setAttribute('aria-selected', 'false');
        }
      });

      // Progress-fill / hover-fill dot stilleri için animation reset — slide
      // değişiminde aktif dot'un dolma animasyonu baştan başlasın (browser
      // aynı animation'ı aynı element'te otomatik restart etmiyor).
      const fillSelector =
        this.dataset.dotStyle === 'progress-fill' ? '.noendy-hero__dot-progress-fill' :
        this.dataset.dotStyle === 'hover-fill' ? '.noendy-hero__dot-fill' :
        null;
      if (fillSelector) {
        const activeDot = this.dots[this.currentIndex];
        if (activeDot) {
          const fill = activeDot.querySelector(fillSelector);
          if (fill) {
            fill.style.animation = 'none';
            // force reflow
            void fill.offsetWidth;
            fill.style.animation = '';
          }
        }
      }
    }

    startAutoplay() {
      if (!this.autoplayEnabled || this.reduceMotion) return;
      this.stopAutoplay();
      this.autoplayId = setInterval(() => this.next(), this.autoplayDuration);
    }

    stopAutoplay() {
      if (this.autoplayId) {
        clearInterval(this.autoplayId);
        this.autoplayId = null;
      }
    }

    restartAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    }

    handleSwipe() {
      if (this.touchStartX == null || this.touchEndX == null) return;
      const delta = this.touchEndX - this.touchStartX;
      const threshold = 50;
      if (Math.abs(delta) < threshold) return;
      if (delta < 0) this.next();
      else this.prev();
      this.restartAutoplay();
      this.touchStartX = null;
      this.touchEndX = null;
    }
  }

  customElements.define('noendy-hero-slider', NoendyHeroSlider);
})();
